import {reactotronRedux} from 'reactotron-redux'
import apisaucePlugin from 'reactotron-apisauce'

const configureReactotron = (name, setupReactotron) => {
	if (process.env.NODE_ENV !== 'production') {
		const tron = setupReactotron(name).use(apisaucePlugin()).use(reactotronRedux()).connect()
		console.tron = tron
		return tron
	} else {
		return null
	}
}

export default configureReactotron
